import React from "react";
import { X } from "lucide-react";

export default function VideoModal({ open, onClose, video }) {
  if (!open || !video) return null;
  const isMp4 = video.type === "mp4";
  return (
    <div
      className="fixed inset-0 z-[100] grid place-items-center p-4 bg-[#1a0b26]/85 backdrop-blur-sm animate-fade-up"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-4xl overflow-hidden rounded-2xl bg-black shadow-2xl ring-1 ring-white/10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 bg-[#1a0b26]">
          <p className="text-[16px] font-semibold text-white truncate">{video.title}</p>
          <button onClick={onClose} className="grid h-9 w-9 place-items-center rounded-lg text-slate-300 hover:bg-white/10 hover:text-white transition-colors" aria-label="Close video">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
          {isMp4 ? (
            <video
              className="absolute inset-0 h-full w-full bg-black"
              src={video.src}
              poster={video.poster}
              controls
              autoPlay
              playsInline
            />
          ) : (
            <iframe
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube.com/embed/${video.id}?autoplay=1&rel=0`}
              title={video.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </div>
    </div>
  );
}
